import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Menu
} from '@mui/material';
import TableSkeleton from 'utils/TableSkeleton';
// import styles from '../../Complaint_Management/complain.module.css';
import styles from '../../SuperAdminDashboard/Complaint_Management/complain.module.css';
import styles2 from './GatePassRequestTable.module.css';
import { display } from '@mui/system';
import { Download, Eye, IdCard, PencilIcon, Trash, Trash2 } from 'lucide-react';
import ViewGatePassModal from './viewGatePass';
import GatePass from './GatePass';
import DeleteModal from './DeleteModal';
import { toast } from 'react-toastify';
import axios from 'axios';
import Cookies from 'js-cookie';
import { ConsoleView } from 'react-device-detect';
import GateRequestModal from './GateRequestModal';

export const getStatusColor = (status) => {
  switch (status.toLowerCase()) {
    case 'pending':
      return { backgroundColor: '#FEF9C3', color: '#CA8A04' };
    case 'rejected':
      return { backgroundColor: '#FEE2E2', color: '#DC2626' };
    case 'in progress':
      return { backgroundColor: '#F3E8FF', color: '#9333EA' };
    case 'approved':
      return { backgroundColor: '#DCFCE7', color: '#16A34A' };
    default:
      return { backgroundColor: 'white', color: 'white' };
  }
};

export const getRequestTypeColor = (type) => {
  switch (type.toLowerCase()) {
    case 'late entry':
      return { backgroundColor: '#DBEAFE', color: '#2563EB' };
    case 'early_departure':
      return { backgroundColor: '#FBCFE8', color: '#BE185D' };
    default:
      return { backgroundColor: '#F3E8FF', color: '#9C27B0' };
  }
};
export function toAmPm(time) {
  if (!time) return '';

  // Already in AM/PM → just return formatted
  if (time.toLowerCase().includes('am') || time.toLowerCase().includes('pm')) {
    const [t, modifier] = time.split(' ');
    let [h, m] = t.split(':').map(Number);

    h = h % 12 || 12;
    return `${h}:${String(m).padStart(2, '0')} ${modifier.toUpperCase()}`;
  }

  // 24-hour format → convert
  const [hours, minutes] = time.split(':').map(Number);
  const suffix = hours >= 12 ? 'PM' : 'AM';
  const adjusted = hours % 12 || 12;

  return `${adjusted}:${String(minutes).padStart(2, '0')} ${suffix}`;
}

export function safeFormatRequestType(value) {
  if (!value || typeof value !== 'string') return 'Not Available (N/A)';

  return value
    .replace(/_/g, ' ')
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function getExpectedArrivalTime(timeRange) {
  if (!timeRange) return 'Not Available';

  const parts = timeRange.split('-').map((t) => t.trim());
  const endTime = parts[1]; // take only the end time

  return endTime || 'Not Available';
}

export function convertToAmPmRange(timeRange) {
  if (!timeRange || typeof timeRange !== 'string' || !timeRange.includes(':')) {
    return 'Not Available (N/A)';
  }

  const convert = (time) => {
    if (!time) return null;
    if (!time.includes(':')) return null;

    const [hourStr, minuteStr] = time.split(':');

    const hour = Number(hourStr);
    const minute = Number(minuteStr);

    if (isNaN(hour) || isNaN(minute)) return null;

    const ampm = hour >= 12 ? 'PM' : 'AM';
    const adjustedHour = hour % 12 || 12;

    return `${String(adjustedHour).padStart(2, '0')}:${String(minute).padStart(2, '0')} ${ampm}`;
  };

  const parts = timeRange.split('-').map((t) => t.trim());

  if (parts.length < 2) return convert(parts[0]) || 'Not Available (N/A)';

  const [start, end] = parts;

  const startConverted = convert(start);
  const endConverted = convert(end);

  if (!startConverted || !endConverted) return 'Not Available (N/A)';

  return `${startConverted} - ${endConverted}`;
}

export function safeToAmPm(time) {
  if (!time || typeof time !== 'string') return 'Not Available (N/A)';

  const trimmed = time.trim();
  if (trimmed === '') return 'Not Available (N/A)';

  // CASE 1 → already AM/PM (06:35 PM)
  if (trimmed.toLowerCase().includes('am') || trimmed.toLowerCase().includes('pm')) {
    return trimmed.toUpperCase(); // just return it
  }

  // CASE 2 → no colon → invalid
  if (!trimmed.includes(':')) return 'Not Available (N/A)';

  const [h, m] = trimmed.split(':').map(Number);

  // CASE 3 → invalid hour/minute
  if (isNaN(h) || isNaN(m)) return 'Not Available (N/A)';

  // Convert 24-hour → AM/PM
  const suffix = h >= 12 ? 'PM' : 'AM';
  const hour12 = h % 12 || 12;

  return `${hour12}:${String(m).padStart(2, '0')} ${suffix}`;
}

export function formatToShortMonth(dateStr) {
  if (!dateStr) return 'Invalid date';

  // Expecting format DD-MM-YYYY
  const [day, month, year] = dateStr.split('-');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const monthIndex = parseInt(month, 10) - 1;
  if (monthIndex < 0 || monthIndex > 11) return 'Invalid date';

  return `${day}-${monthNames[monthIndex]}-${year}`;
}

const GatePassRequestTable = ({ data = [], setPage, onDeleteGatePass, page, setRowsPerPage, rowsPerPage, totalRecords, fetchRequests }) => {
  // const [page, setPage] = useState(0);c
  // console.log('--->', data);

  // const [rowsPerPage, setRowsPerPage] = useState(20);
  const truncateWords = (text, maxWords = 10) => {
    const value = typeof text === 'string' ? text.trim() : '';
    if (!value) return '';
    const words = value.split(/\s+/);
    if (words.length <= maxWords) return value;
    return `${words.slice(0, maxWords).join(' ')}...`;
  };

  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewGatePass, setViewGatePass] = useState(false);
  const [gatePassDeleteModalOpen, setGatePassDeleteModalOpen] = useState(false);

  const [GateRequestModalOpen, setGateRequestModalOpen] = useState(false);

  const handleMenuOpen = (event, request) => {
    setAnchorEl(event.currentTarget);
    setSelectedRequest(request);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDeleteGatePass = async (request) => {
    try {
      const token = Cookies.get('Token'); // Adjust the token retrieval as per your auth setup
      const requestId = request?._id; // Use _id (mapped from API's 'id')
      const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/gate_pass/gatepass/${requestId}`, {
        headers: {
          Authorization: `Bearer ${token}` // 👈 Attach token in header
        }
      });

      // ✅ Always show backend message (if provided)
      if (response?.data?.message) {
        toast.success(response.data.message);
        if (onDeleteGatePass) onDeleteGatePass();
      }
    } catch (error) {
      // ✅ Show backend error message only
      const backendMessage = error?.response?.data?.message || 'An error occurred while deleting gate pass.';
      toast.error(backendMessage);
      console.error('Error deleting gate pass:', error);
    }
  };
  const handleOpenGateRequestModal = (request) => {
    // console.log('request in gate request modal', request);
    setSelectedRequest(request);
    setGateRequestModalOpen(true);
    handleMenuClose();
  };

  const handleViewDetails = (request) => {
    setSelectedRequest(request);
    setViewModalOpen(true);
    handleMenuClose();
  };
  const handleViewGatepass = (request) => {
    // console.log('gatepass data', request);

    setSelectedRequest(request);
    setViewGatePass(true);
    handleMenuClose();
  };
  useEffect(() => {
    // console.log('Gate Pass Requests data:', data);
  }, [data]);
  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(timer);
  }, [data]);

  const filteredRequests = Array.isArray(data) ? data : [];
  const totalPages = Math.ceil(totalRecords / rowsPerPage);
  // const data = filteredRequests.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box className={styles2.wrapper}>
      <Box className={styles.container}>
        {/* Header */}
        <Box className={`${styles.contentHeader} ${styles2.exportBtnContainer}`}>
          <Typography className={styles.contentTitle}>Request History ({filteredRequests.length})</Typography>
          {/* <button className={styles2.exportBtn}>
            <Download width={16} height={16} />
            <span>Export</span>
          </button> */}
        </Box>

        {/* Table */}
        <TableContainer component={Paper} className={styles.tableContainer}>
          {loading ? (
            <TableSkeleton />
          ) : (
            <Table>
              <TableHead>
                <TableRow className={styles.tableHeaderRow}>
                  <TableCell className={styles.tableHeaderCell}>Request ID</TableCell>
                  {/* <TableCell className={styles.tableHeaderCell}>Student Name</TableCell>
                  <TableCell className={styles.tableHeaderCell}>UID</TableCell>
                  <TableCell className={styles.tableHeaderCell}>Category</TableCell> */}
                  <TableCell className={styles.tableHeaderCell}>Request Type</TableCell>
                  <TableCell className={styles.tableHeaderCell}>Duration</TableCell>
                  <TableCell className={styles.tableHeaderCell}>Reason</TableCell>
                  <TableCell className={styles.tableHeaderCell}>Status</TableCell>
                  <TableCell className={styles.tableHeaderCell}>Submitted</TableCell>
                  <TableCell className={styles.tableHeaderCell}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9} style={{ textAlign: 'center', padding: '10px' }}>
                      No Requests Found
                    </TableCell>
                  </TableRow>
                ) : (
                  data.map((req) => (
                    <TableRow key={req._id} className={styles.tableRow}>
                      <TableCell className={styles.tableCell}>{req.requestId || 'Not Available (N/A)'}</TableCell>
                      {/* <TableCell className={styles.tableCell}>{req.student?.name || 'Not Available (N/A)'}</TableCell>
                      <TableCell className={styles.tableCell}>{req.student?.id ? `...${req.student.id.slice(-6)}` : 'Not Available (N/A)'}</TableCell>
                      <TableCell className={styles.tableCell}>{req.category || 'Not Available (N/A)'}</TableCell> */}
                      <TableCell className={styles.tableCell}>
                        {req.requestType ? (
                          <Chip
                            label={safeFormatRequestType(req.requestType)}
                            style={{
                              ...getRequestTypeColor(req.requestType),
                              fontWeight: 600,
                              letterSpacing: '0.5px',
                              paddingRight: 6,
                              paddingLeft: 6,
                              paddingTop: 4,
                              paddingBottom: 4,
                              fontSize: 12
                            }}
                            size="small"
                            className={styles.statusChip} // reuse statusChip class for consistent styling
                          />
                        ) : (
                          '-'
                        )}
                      </TableCell>
                      <TableCell className={styles.tableCell}>
                        <div style={{ color: '#1F2937', fontWeight: 400, fontSize: 14 }}>{formatToShortMonth(req?.duration?.date)}</div>

                        {(req.requestTypeOriginal === 'late_entry' || req.requestTypeOriginal === 'early_departure') && req.toTime && (
                          <div style={{ color: '#9CA3AF', fontWeight: 500, fontSize: 12 }}>{safeToAmPm(req?.toTime)}</div>
                        )}

                        {req.requestTypeOriginal === 'leave' && req.duration.toDate && (
                          <div style={{ color: '#9CA3AF', fontWeight: 500, fontSize: 12 }}>
                            to {formatToShortMonth(req.duration.toDate)}
                          </div>
                        )}
                      </TableCell>

                      <TableCell className={styles.tableCell}>
                        {req.reason ? truncateWords(req.reason, 10) : 'Not Available (N/A)'}
                      </TableCell>
                      <TableCell className={styles.tableCell}>
                        <Chip
                          label={req.status}
                          style={{
                            ...getStatusColor(req.status),
                            fontWeight: 600,
                            letterSpacing: '0.5px'
                          }}
                          size="small"
                          className={styles.statusChip}
                        />
                      </TableCell>
                      <TableCell style={{ color: '#9CA3AF' }} className={styles.tableCell}>
                        {req.submittedAt
                          ? new Intl.DateTimeFormat('en-GB', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric'
                            }).format(new Date(req.submittedAt))
                          : 'Not Available (N/A)'}
                      </TableCell>
                      <TableCell className={styles.tableCell}>
                        <button
                          type="button"
                          className={styles2.actionBtn} // create similar style as StudentManagement
                          onClick={(e) => {
                            handleMenuOpen(e, req);
                            // console.log('table req ' + req);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') handleMenuOpen(e, req);
                          }}
                          aria-label={`Actions for request ${req.requestId}`}
                        >
                          <img src="/actionBtn.svg" alt="Actions" style={{ pointerEvents: 'none' }} />
                        </button>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          )}
        </TableContainer>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{ elevation: 8, className: styles2.actionsMenu }}
        >
          <MenuItem onClick={() => handleViewDetails(selectedRequest)} className={styles.menuItem}>
            <Box className={styles.menuView}>
              <Eye size={16} height={16} width={16} color="#1F2937" /> View Details
            </Box>
          </MenuItem>

          {selectedRequest?.status?.toLowerCase() === 'pending' && (
            <>
              <MenuItem onClick={() => handleOpenGateRequestModal(selectedRequest)} className={styles.menuItem}>
                <Box className={styles.menuView}>
                  <PencilIcon size={16} height={16} width={16} color="#1F2937" /> Edit Details
                </Box>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setGatePassDeleteModalOpen(true);
                  handleMenuClose();
                }}
                className={styles.menuItem}
              >
                <Box className={styles.menuView}>
                  <Trash2 size={16} height={16} width={16} color="#1F2937" /> Delete Request
                </Box>
              </MenuItem>
            </>
          )}
          {selectedRequest?.status?.toLowerCase() === 'approved' && (
            <MenuItem onClick={() => handleViewGatepass(selectedRequest)} className={styles.menuItem}>
              <Box className={styles.menuView}>
                <IdCard size={16} height={16} width={16} color="#1F2937" /> View gatepass
              </Box>
            </MenuItem>
          )}
        </Menu>

        {/* View Details Modal */}
        <ViewGatePassModal open={viewModalOpen} onClose={() => setViewModalOpen(false)} data={selectedRequest} />
        <GatePass open={viewGatePass} onClose={() => setViewGatePass(false)} data={selectedRequest} />
        <DeleteModal
          open={gatePassDeleteModalOpen}
          onClose={() => setGatePassDeleteModalOpen(false)}
          onConfirm={() => {
            // console.log('Delete confirmed for request:', selectedRequest);
            handleDeleteGatePass(selectedRequest);
            setGatePassDeleteModalOpen(false);
          }}
        />

        {/* Pagination Footer - Styled like ComplaintManagement */}
        <Box className={styles.paginationContainer}>
          <Box className={styles.paginationInfo}>
            <Typography variant="body2" className={styles.paginationText}>
              Showing {totalRecords === 0 ? 0 : page * rowsPerPage + 1}-{Math.min((page + 1) * rowsPerPage, totalRecords)} of {totalRecords}
            </Typography>
          </Box>

          <Box className={styles.paginationControls}>
            <FormControl size="small" className={styles.rowsPerPage}>
              <InputLabel>Rows per page</InputLabel>
              <Select value={rowsPerPage} label="Rows per page" onChange={handleChangeRowsPerPage}>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>

            <Typography variant="body2" className={styles.pageInfo}>
              Page {totalRecords === 0 ? 0 : page + 1} of {Math.ceil(totalRecords / rowsPerPage) || 1}
            </Typography>

            <Box className={styles.navigationButtons}>
              <IconButton onClick={() => setPage(0)} className={styles2.paginationBtn} disabled={page === 0} aria-label="First page">
                <img src="/chevrons-left.svg" alt="first page" />
              </IconButton>
              <IconButton
                onClick={() => setPage(page - 1)}
                className={styles2.paginationBtn}
                disabled={page === 0}
                aria-label="Previous page"
              >
                <img src="/chevron-left.svg" alt="previous page" />
              </IconButton>
              <IconButton
                onClick={() => setPage(page + 1)}
                className={styles2.paginationBtn}
                disabled={page >= totalPages - 1}
                aria-label="Next page"
              >
                <img src="/chevron-right.svg" alt="next page" />
              </IconButton>
              <IconButton
                onClick={() => setPage(totalPages - 1)}
                className={styles2.paginationBtn}
                disabled={page >= totalPages - 1}
                aria-label="Last page"
              >
                <img src="/chevrons-right.svg" alt="last page" />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Box>
      <GateRequestModal
        open={GateRequestModalOpen}
        onClose={() => {
          setGateRequestModalOpen(false);
          setSelectedRequest(null);
        }}
        onSubmit={(payload) => {
          // console.log('submit gate request', payload);
          setGateRequestModalOpen(false);
        }}
        edit={Boolean(selectedRequest && (selectedRequest._id || selectedRequest.requestId))}
        selectedData={selectedRequest}
        fetchRequests={fetchRequests}
      />
    </Box>
  );
};

export default GatePassRequestTable;
